var Transitions = /*#__PURE__*/ function(Transitions) {
    Transitions["FadeIn"] = "fade-in";
    Transitions["FadeInSlide"] = "fade-in-slide";
    return Transitions;
}({});

export { Transitions };
//# sourceMappingURL=transitions.js.map
